'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002497 from "./presto.types$$anon$97.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$96() {
  this.c3q = null;
  this.c3i = null;
  this.c3j = false;
  this.c3r = null;
  this.c3s = false;
  this.c3v = null;
  this.c3o = null;
  this.c3p = false;
  this.c3k = null;
  this.c3l = false;
  this.c3m = null;
  this.c3n = false;
  this.c3t = false;
  this.c3u = false;
  this.c3q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c3v = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$96 as $c_Lpresto_types$$anon$96 };
$p = $c_Lpresto_types$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$96;
/** @constructor */
function $h_Lpresto_types$$anon$96() {
}
export { $h_Lpresto_types$$anon$96 as $h_Lpresto_types$$anon$96 };
$h_Lpresto_types$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c3q;
});
$p.L = (function() {
  if ((!this.c3j)) {
    this.c3i = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c3j = true;
  }
  return this.c3i;
});
$p.O = (function() {
  if ((!this.c3s)) {
    this.c3r = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c3s = true;
  }
  return this.c3r;
});
$p.E = (function() {
  return this.c3v;
});
$p.t = (function() {
  if ((!this.c3p)) {
    this.c3o = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3p = true;
  }
  return this.c3o;
});
$p.M = (function() {
  if ((!this.c3l)) {
    this.c3k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c3l = true;
  }
  return this.c3k;
});
$p.Q = (function() {
  if ((!this.c3n)) {
    this.c3m = new $j_presto$002etypes$0024$0024anon$002497.$c_Lpresto_types$$anon$97();
    this.c3n = true;
  }
  return this.c3m;
});
$p.w = (function() {
  if ((!this.c3u)) {
    this.c3t = false;
    this.c3u = true;
  }
  return this.c3t;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee127) => ((p) => \u03b4scrutinee127.crr(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$96, "presto.types$$anon$96", ({
  Yj: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$96 as $d_Lpresto_types$$anon$96 };
//# sourceMappingURL=presto.types$$anon$96.js.map
